import { keys, reduce } from "lodash";
import { InputError } from "../../../hooks/use-form";
import { FinancialCalculator } from "../../../models/classes/financial-calculator/FinancialCalculator.class";


export const validateFinancialCalculator = (values: FinancialCalculator) => {
  const fields = keys(values) as (keyof FinancialCalculator)[];
  const errors: any = reduce(
    fields,
    (result, field: keyof FinancialCalculator) => {
      let validatedResult = validateFinancialCalculatorFields(values, field);
      return { ...result, [field]: validatedResult };
    },
    {}
  );
  return errors;
}

export const validateFinancialCalculatorFields = (values: any, name: keyof FinancialCalculator) => {
  const value = values[name];

  let error: InputError[] = [{ isValid: true }];

  switch (name) {
    case "flatType":
      if (!value) {
        error = [{ isValid: false, message: "This is a required field." }];
      }
      break;
    case "isThereOutstandingLoan":
    case "isThereNewLoan":
      if (value === undefined) {
        error = [{ isValid: false, message: "This is a required field." }];
      }
      break;
  }

  return error;
};
